<template>
  <v-container>
    <pst-form
      :presumptiveDataEach="presumptiveDataEach"
      @emitPresumptiveData="addTimes"
    />
  </v-container>
</template>

<script>
import PstForm from "@/components/presumptive/PstForm.vue";
import { mapState } from "vuex";

export default {
  components: {
    PstForm,
  },
  computed: {
    ...mapState("Presumptive", ["presumptiveDataEach"]),
  },
  methods: {
    addTimes(data) {
      
      this.$store.dispatch("Presumptive/addTimes", data).then(() => {
        this.$router.back();
      });
    },
  },
  created() {
    this.$store.dispatch(
      "Presumptive/getPresumptiveEach",
      this.$route.params.id
    );
  },
};
</script>
